<template>
  <div class="links">
    <homeColumnTitle
      v-if="links.length"
      :title="title"
      :can-click="false"
    />
    <div class="item-wrapper">
      <div class="item-container">
        <div
          v-for="item in links"
          :key="item.id"
          class="item"
          :title="item.name"
          @click="clickLink(item)"
        >
          <web-img
            v-if="!item.iconError && item.linkIcon && showMode == '1'"
            :src="item.linkIcon"
            fit="contain"
            width="100%"
            height="100%"
            @error="item.iconError = true"
          />
          <span v-else>{{ item.name }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import homeColumnTitle from '../homeColumnTitle';
import webImg from '../webImg';
import api from '../../../proxy';
import { openUrl } from '../../../../../../lib/utils';

export default {
    name: 'Links',
    components: {
        homeColumnTitle, webImg,
    },
    props: {
        title: {
            type: String,
            default: '友情链接',
        },
    },
    data () {
        return {
            showMode: '0', // 0 文本  1 图标
            links: [],
        };
    },
    async created () {
        const { siteId } = this.$route.query;
        const res1 = await api.getLinkMode({ siteId });
        if (res1.errcode === 0) {
            this.showMode = res1.data.showLabel;
        } else {
            this.$message.error(res1.errmsg);
        }
        const res2 = await api.getLinks({ webSiteId: siteId, pageNo: 1, pageSize: 999 });
        if (res2.errcode === 0) {
            this.links = res2.data.list.map(itm => Object.assign(itm, { iconError: false }));
        } else {
            this.$message.error(res2.errmsg);
        }
        this.$emit('linkNum', this.links.length);
    },
    methods: {
        clickLink (item) {
            openUrl(item.link);
        },
    },
};
</script>

<style scoped lang="scss">
@import "../../style.scss";
.links {
    width: $pageWidth;
    margin: 0px auto;
    background-color: #FFFFFF;
    //padding-bottom: 40px;
    //margin-top: 30px;
    .item-wrapper {
        width: 100%;
        display: flex;
        justify-content: center;
        .item-container {
            display: flex;
            flex-wrap: wrap;
            .item {
                width: 226px;
                height: 80px;
                display: flex;
                align-items: center;
                justify-content: center;
                overflow: hidden;
                text-overflow:ellipsis;
                white-space: nowrap;
                box-sizing: border-box;
                border-radius: 4px;
                border: 1px solid #E3E8EE;
                user-select: none;
                cursor: pointer;
                font-size: 18px;
                color: #9EA7B4;
                transition: all 0.3s;
                margin-right: 20px;
                margin-bottom: 20px;
                &:nth-child(5n) {
                    margin-right: 0;
                }
                &:hover {
                    box-shadow: 2px 4px 10px 0px rgba(0, 0, 0, 0.1);
                    color: #464C5B;
                }
            }
        }
    }
}
</style>
